/* eslint-disable no-template-curly-in-string */
export default {
  es: {
    noData: 'No hay registro de datos',
    Si: 'Si',
    No: 'No',
    join: 'Unirse',
    of: 'de',
    January: 'Enero',
    February: 'Febrero',
    March: 'Marzo',
    April: 'Abril',
    May: 'Mayo',
    June: 'Junio',
    July: 'Julio',
    August: 'Agosto',
    September: 'Septiembre',
    October: 'Octubre',
    November: 'Noviembre',
    December: 'Diciembre',
    shortMonths: {
      January: 'Ene',
      February: 'Feb',
      March: 'Mar',
      April: 'Abr',
      May: 'May',
      June: 'Jun',
      July: 'Jul',
      August: 'Ago',
      September: 'Sep',
      October: 'Oct',
      November: 'Nov',
      December: 'Dic'
    },
    show: 'Mostrar',
    hide: 'Ocultar',
    save: 'Guardar',
    edit: 'Editar',
    delete: 'Eliminar',
    required: '${label} es requerido.',
    wrongEmail: 'Este no es un email válido!',
    cancel: 'Cancelar',
    confirm: 'Confirmar',
    search: 'Buscar...',
    filter: 'Filtrar',
    name: 'Nombre',
    description: 'Descripción',
    actions: 'Acciones',
    details: 'Ver',
    myRecDetails: 'Detalles',
    goback: 'Regresar',
    add: 'Añadir',
    problem: 'Ocurrió un problema!',
    emailType: 'Este no es un correo válido',
    resetPass: 'Reiniciar password',
    recommendation: 'Recomendación',
    noRecommendations: 'Aún no tienes recomendaciones',
    noAppointments: 'No hay registro de citas',
    errorAgendamate: 'Error al cargar las citas disponibles',
    appointSubtitle: 'Puedes solicitar una con el botón superior.',
    tryLaterAgendamate:
      'Se ha presentado un error con el servicio de Agendamate, por favor inténtelo más tarde.',
    Cumple: 'Cumple',
    'No Cumple': 'No Cumple',
    'No cumple': 'No Cumple',
    activeVideoCalls: 'Tiene videollamadas activas',
    noActiveVideoCalls: 'No tiene videollamadas activas',
    deleteCategory: '¿Estás seguro que deseas eliminar esta categoría?',
    deleteSection: '¿Estás seguro que deseas eliminar esta sección?',
    cantDeleteCategory:
      'No es posible eliminar esta categoría, ya que contiene otras secciones',
    cantDeleteSection:
      'No es posible eliminar esta sección, ya que contiene otros elementos',
    userDeleted: 'El usuario ha sido eliminado'
  },
  en: {
    noData: 'There are not datas registered',
    Si: 'Yes',
    No: 'No',
    join: 'Join',
    of: 'of',
    January: 'January',
    February: 'February',
    March: 'March',
    April: 'April',
    May: 'May',
    June: 'June',
    July: 'July',
    August: 'August',
    September: 'September',
    October: 'October',
    November: 'November',
    December: 'December',
    shortMonths: {
      January: 'Jan',
      February: 'Feb',
      March: 'Mar',
      April: 'Apr',
      May: 'May',
      June: 'Jun',
      July: 'Jul',
      August: 'Aug',
      September: 'Sep',
      October: 'Oct',
      November: 'Nov',
      December: 'Dec'
    },
    show: 'Show',
    hide: 'Hide',
    save: 'Save',
    edit: 'Edit',
    delete: 'Delete',
    required: '${label} is required.',
    wrongEmail: 'It is not a valid email!',
    cancel: 'Cancel',
    confirm: 'Confirm',
    search: 'Search...',
    filter: 'Filter',
    name: 'Name',
    description: 'Description',
    actions: 'Actions',
    details: 'Details',
    myRecDetails: 'Details',
    goback: 'Go back',
    add: 'Add',
    problem: 'Problem occurred!',
    emailType: 'This is not a valid email',
    resetPass: 'Reset password',
    recommendation: 'Recommendation',
    noRecommendations: `You don't have any recommendations yet`,
    noAppointments: `There is no appointments record`,
    errorAgendamate: 'Error loading available appointments',
    appointSubtitle: 'You can request one with the button above.',
    tryLaterAgendamate:
      'An error has occurred with the Agendamate service, please try again later.',
    Cumple: 'Apply',
    'No Cumple': 'Not Apply',
    'No cumple': 'Not Apply',
    activeVideoCalls: 'You have active videocalls',
    noActiveVideoCalls: 'You have not active videocalls',
    deleteCategory: 'Do you want to delete this category?',
    deleteSection: 'Do you want to delete this section?',
    cantDeleteCategory:
      'It is not possible to delete this category as it contains other sections',
    cantDeleteSection:
      'It is not possible to delete this section as it contains other elements',
    userDeleted: 'The user has been deleted'
  }
};
